/**
 * CookieYes, GDPR Cookie Consent (Cookie Law Info)
 * https://wordpress.org/plugins/cookie-law-info/
 */

export const cookieyes = {

	/**
	 * Get the CookieYes cookies
	 *
	 * @returns {{statistics: boolean, marketing: boolean, preferences: boolean, necessary: boolean}|null}
	 */
	getConsent: () => {

		/**
		 * Process the new cookieyes-consent cookie that contains all the information
		 */

		    // on first load CookieYes sets the categories with no values (facepalm)
		    // let consent = "consentid:cWZkOGRjNzFzb1R3a0I4VlJMYXM1ZEJjVEs5aU4zcTQ,consent:,action:,necessary:,functional:,analytics:,performance:,advertisement:,other:"
			// let consent = "consentid:cnpZSGg2SDZzWXJodEc3TWF3UTdKVVM3UmtKWHc3SEk,consent:yes,action:yes,necessary:yes,functional:yes,analytics:no,performance:yes,advertisement:yes"
		let consent = pmw.getCookie("cookieyes-consent")

		if (consent) {

			// This cookie has the following structure:
			// consentid:cnpZSGg2SDZzWXJodEc3TWF3UTdKVVM3UmtKWHc3SEk,consent:yes,action:yes,necessary:yes,functional:yes,analytics:no,performance:yes,advertisement:yes
			// First split the comma-separated values into an array
			// Then split each array item into a key value pair. The key and the value are separated by a colon.
			// Then create an object from the key value pairs.
			const values = consentToJson(consent)

			/**
			 * CookieYes writes the cookieyes-consent cookie on the very first page
			 * view, before the visitor has answered the banner. What it holds then
			 * varies by the law it thinks applies, so only the action says whether
			 * a decision exists. See hasAnsweredBanner().
			 *
			 * Reading anything else as a decision marks the visitor as having
			 * chosen, which makes PMW skip the region check, so a visitor outside
			 * the configured explicit consent regions stayed blocked instead of
			 * being unlocked. Sibling of the Cookie Script guard in
			 * cookie-script.mjs and the Complianz guard in complianz.mjs.
			 *
			 * The new cookie is authoritative about whether a decision exists, so we
			 * do not fall through to the legacy cookielawinfo-* cookies here.
			 */
			if (!hasAnsweredBanner(values)) {
				pmw.console.log("CookieYes cookie detected, but the visitor hasn't answered the banner yet. Ignoring it.")
				return null
			}

			pmw.console.log("CookieYes CMP consent detected")

			// The visitor has decided. For the three tracking categories every value
			// that is not an explicit "yes" is a denial, which keeps the "" to false
			// mapping for a category CookieYes left empty in a decided cookie.
			// Necessary follows the other CMP readers instead: it is allowed unless
			// it has been denied explicitly.
			return {
				statistics : values.analytics === "yes",
				marketing  : values.advertisement === "yes",
				preferences: values.functional === "yes",
				necessary  : values.necessary !== "no",
			}
		}

		/**
		 * Check if at least one of the cookies is set
		 *
		 * @param cookieNames
		 * @returns {boolean}
		 */
		const isOneCookieSet = (cookieNames) => {
			for (let key in cookieNames) {
				for (let cookieName of cookieNames[key]) {
					if (pmw.getCookie(cookieName)) {
						return true
					}
				}
			}
			return false
		}

		/**
		 * Process the old cookieyes-* cookies
		 *
		 * @param cookieNames
		 * @returns {boolean}
		 */
		const getCookieValue = (cookieNames) => {

			for (let cookieName of cookieNames) {
				let value = pmw.getCookie(cookieName)
				if (value === "yes") {
					return true
				} else if (value === "no") {
					return false
				}
			}

			return true
		}

		const cookieNames = {
			statistics : [
				"cookielawinfo-checkbox-analytics",
				"cookielawinfo-checkbox-analytiques",
				"cookieyes-analytics",
			],
			marketing  : [
				"cookielawinfo-checkbox-advertisement",
				"cookielawinfo-checkbox-performance",
				"cookielawinfo-checkbox-publicite",
				"cookieyes-advertisement",
			],
			preferences: [
				"cookielawinfo-checkbox-functional",
				"cookielawinfo-checkbox-preferences",
				"cookieyes-functional",
			],
			necessary  : [
				"cookielawinfo-checkbox-necessary",
				"cookielawinfo-checkbox-necessaire",
				"cookieyes-necessary",
			],
		}

		// If at least one of the cookies is set to "yes" or "no", then return the CookieYes consent
		if (isOneCookieSet(cookieNames)) {

			pmw.console.log("CookieYes CMP consent detected")

			return  {
				statistics : getCookieValue(cookieNames.statistics),
				marketing  : getCookieValue(cookieNames.marketing),
				preferences: getCookieValue(cookieNames.preferences),
				necessary  : getCookieValue(cookieNames.necessary),
			}
		}

		return null
	},

	loadEventListeners: () => {

		document.addEventListener("cookieyes_consent_update", (e) => {

			/**
			 * CookieYes fires this event for its own pre-decision defaults too, not
			 * only for an answered banner: both default writers end in a
			 * cookieyes_consent_update dispatch on the first page view. The event
			 * detail carries the categories but nothing that tells the two apart,
			 * so we ask the store the same question the cookie reader asks.
			 *
			 * Without this, the "no law applies here" default relayed a grant for
			 * every category before the visitor had answered anything.
			 *
			 * CookieYes writes the cookie before it dispatches, so the action is
			 * already in place by the time we read it here.
			 */
			if (!hasAnsweredBanner(consentToJson(pmw.getCookie("cookieyes-consent") || ""))) {
				pmw.console.log("CookieYes consent update received, but the visitor hasn't answered the banner yet. Ignoring it.")
				return
			}

			let data = {
				statistics : e.detail.accepted.includes("analytics"),
				marketing  : e.detail.accepted.includes("advertisement"),
				preferences: e.detail.accepted.includes("functional"),
				necessary  : e.detail.accepted.includes("necessary"),
			}

			pmw.consent.api.updateSelectively({...data, source: "cmp"})
		}, true)
	},
}

/**
 * Whether the cookieyes-consent cookie carries an answered banner.
 *
 * "action:yes" is the one and only answer signal. CookieYes defines its own
 * public isUserActionCompleted as `"yes" === _ckyGetFromStore("action")`, and
 * it shows the banner on `!_ckyGetFromStore("action")`, so nothing else in the
 * cookie states whether a visitor decided.
 *
 * The "consent" key in particular does not, and reading it as one is how a
 * banner nobody had answered was read as consent. Before the visitor answers,
 * CookieYes writes a default set through one of two functions, and neither of
 * them writes an action:
 *
 *   - the regional default writes `consent:no` (`consent:yes` under CCPA with
 *     Global Privacy Control) and leaves action absent,
 *   - the "no law applies here" default writes `action:no` with `consent:yes`
 *     and grants every category.
 *
 * So every pre-decision state carries an explicit consent value, and accepting
 * it marked the visitor as having chosen. That skips the region check in
 * countryUnlock(), which leaves a visitor outside the configured explicit
 * consent regions blocked for good. Ticket 3448373394, geistlich.us: a US
 * shop on CookieYes where the Meta pixel never loaded, so no browser purchase
 * event and no _fbp cookie was ever written.
 *
 * @param values {Object} - the raw key value pairs of the cookie
 * @returns {boolean}
 */
const hasAnsweredBanner = (values) => values.action === "yes"

/**
 * Turn the comma separated cookie into its raw key value pairs.
 *
 * The values stay strings on purpose. On the first page view CookieYes writes
 * every category as an empty string, and an empty string must stay
 * distinguishable from an explicit "no".
 *
 * @param consent {string}
 * @returns {Object}
 */
const consentToJson = (consent) => {

	let consentObj = {}

	consent.split(",").forEach((item) => {
		let [key, value] = item.split(":")
		consentObj[key]  = value
	})

	return consentObj
}
